export default __webpack_public_path__ + "static/media/apollo-graphql-compact.982c748f.svg";